export default {
  /* -------------------------------------------------------------------------- */
  /*                             Category List State                            */
  /* -------------------------------------------------------------------------- */
  listLoading: false,
  BannerRecords: [],
  total: 0,
  FilteredCount: 0,
  /* -------------------------------------------------------------------------- */
  /*                            Create Category State                           */
  /* -------------------------------------------------------------------------- */
  createLoading: false,
  /* -------------------------------------------------------------------------- */
  /*                             Edit Category State                            */
  /* -------------------------------------------------------------------------- */
  editLoading: false,
}
